/** Roadmap 03/2027 · CMDB do CITSmart (contrato do Autonomous): assistente, tela da conexão e ficha do ativo. */
const en = {
  'ccm.impact': "{n} CIs will be resent once on the next run ({attrs} by attributes, {rels} only by relationships). Do it outside peak hours.",
  'perm.action.citsmartCmdb.enable': "Turn on the sending to the CITSmart CMDB",
  'ccm.title': "CITSmart CMDB",
  'ccm.lead': "Hive feeds the CITSmart CMDB with the contract agreed with Autonomous: queue createOrUpdateList, ci_id HIVE-…, only what changed, return by webhook. Every 10 minutes while the sending is on.",
  'ccm.off.untested': "The sending is off. Test the connector (Keycloak token and queue route), check the preview and then turn the sending on.",
  'ccm.off.tested': "The sending is off. The last test passed: check the preview and turn the sending on.",
  'ccm.autonomous.confirmed': "{who} confirmed on {at} that the CITSmart CMDB of Autonomous is off.",
  'ccm.enable.switch': "Sending on",
  'ccm.enable.title': "Turn on the sending to the CITSmart CMDB?",
  'ccm.enable.text': "The next run sends every eligible asset that changed. Do it outside peak hours on the first time.",
  'ccm.enable.autonomous': "The integration with Autonomous is on in this installation. Only one platform may feed the CITSmart CMDB of a client, or the same machine becomes two CIs (AUT-… and HIVE-…). Confirm that the CITSmart CMDB of Autonomous is off.",
  'ccm.enable.confirmAutonomous': "The CMDB of Autonomous is off: turn on",
  'ccm.enable.ok': "Turn on",
  'ccm.enable.on': "CITSmart CMDB sending turned on.",
  'ccm.enable.off': "CITSmart CMDB sending turned off.",
  'ccm.send.now': "Send now",
  'ccm.send.kind': "Send by type…",
  'ccm.send.byKind': "Send this type",
  'ccm.send.title': "Send now?",
  'ccm.send.kindTitle': "Send only {kind}?",
  'ccm.send.text': "{n} eligible assets are checked; only what changed is sent. A run already going makes this one skipped (recorded in the audit).",
  'ccm.send.ok': "Send",
  'ccm.send.running': "Sending…",
  'ccm.send.done': "{sent} sent, {unchanged} unchanged, {failed} with error, {waiting} awaiting return.",
  'ccm.send.stopped': "The run stopped: {why}.",
  'ccm.queueLink': "Open the queue in CITSmart",
  'ccm.kpis': "CITSmart CMDB indicators",
  'ccm.k.eligible': "Eligible",
  'ccm.k.created': "Created",
  'ccm.k.updated': "Updated",
  'ccm.k.awaiting': "Awaiting return",
  'ccm.k.oldest': "oldest {at}",
  'ccm.k.errors': "With error",
  'ccm.k.backoff': "{n} waiting to retry",
  'ccm.k.excluded': "Left out",
  'ccm.excluded': "Left out:",
  'ccm.why.kind': "type not chosen",
  'ccm.why.duplicate': "possible duplicate under review",
  'ccm.why.merged': "merged into another asset",
  'ccm.why.retired': "retired",
  'ccm.last.origin': "Last run",
  'ccm.last.when': "Started",
  'ccm.last.duration': "Duration",
  'ccm.last.sent': "Result",
  'ccm.last.counts': "{sent} sent · {unchanged} unchanged · {failed} errors",
  'ccm.last.stopped': "Stopped",
  'ccm.last.notStopped': "No",
  'ccm.origin.loop': "Automatic (every 10 min)",
  'ccm.origin.now': "Send now",
  'ccm.origin.kind': "Send by type",
  'ccm.gone': "{n} CIs were retired or merged in Hive but are still active in CITSmart: the contract has no route to inactivate them yet (see the CIs tab).",
  'ccm.tabs': "CITSmart CMDB sections",
  'ccm.tab.webhook': "Return (webhook)",
  'ccm.tab.preview': "CI preview",
  'ccm.tab.attempts': "Audit",
  'ccm.tab.runs': "Runs",
  'ccm.tab.cis': "CIs",
  'ccm.wh.mode': "Return",
  'ccm.wh.async': "Asynchronous by webhook (error after {h} h without return)",
  'ccm.wh.sync': "Transition: a 2xx answer counts as accepted",
  'ccm.wh.url': "Webhook address (give it to CITSmart)",
  'ccm.wh.header': "Token header",
  'ccm.wh.token': "Token",
  'ccm.wh.tokenSet': "Configured (only its SHA-256 is kept)",
  'ccm.wh.tokenMissing': "Not generated: the webhook answers 503",
  'ccm.wh.version': "Attribute selection version",
  'ccm.wh.route': "Queue route",
  'ccm.wh.tested': "Last passing test",
  'ccm.wh.generate': "Generate token",
  'ccm.wh.new': "Generate new token",
  'ccm.wh.newTitle': "Replace the webhook token?",
  'ccm.wh.newText': "The current token stops working at once: CITSmart must get the new one.",
  'ccm.wh.once': "Copy it now: it is shown only once.",
  'ccm.wh.network': "Turn on the asynchronous return only after CITSmart is calling the webhook. CITSmart must reach this address; the test only proves that Hive reaches CITSmart, not the other way round.",
  'ccm.pv.search': "Asset (name, IP or serial)",
  'ccm.pv.find': "Find",
  'ccm.pv.excluded': "This asset does not go to the CMDB: {why}.",
  'ccm.pv.nulls': "Without source in Hive (sent as null or empty): {list}",
  'ccm.pv.held': "Relationship {type} not sent yet: {why}.",
  'ccm.pv.payload': "Exact envelope and jsondata",
  'ccm.held.target-not-accepted': "the other end has not been accepted by CITSmart yet (it goes in the send after the confirmation)",
  'ccm.held.target-not-sent': "the other end is not sent to the CMDB (type not chosen, duplicate or retired)",
  'ccm.at.ciId': "ci_id",
  'ccm.at.outcome': "Outcome",
  'ccm.at.from': "From",
  'ccm.at.when': "When",
  'ccm.at.asset': "Asset",
  'ccm.at.result': "Return",
  'ccm.at.empty': "No attempt with these filters.",
  'ccm.at.detail': "Attempt {id}",
  'ccm.at.payload': "Payload sent",
  'ccm.at.response': "HTTP answer",
  'ccm.at.results': "Results received from CITSmart",
  'ccm.out.accepted': "Accepted",
  'ccm.out.sent': "Sent, awaiting return",
  'ccm.out.failed': "Failed",
  'ccm.out.reserved': "Reserved",
  'ccm.out.awaiting-not-resent': "Awaiting return, not resent",
  'ccm.out.no-return': "No return in time",
  'ccm.out.not-configured': "Not configured",
  'ccm.out.skipped-run': "Run skipped",
  'ccm.out.breaker-open': "Run stopped (breaker)",
  'ccm.runs.empty': "No run yet.",
  'ccm.cis.state': "State",
  'ccm.cis.last': "Last return",
  'ccm.cis.empty': "No CI with this state.",
  'ccm.cis.merged': "merged into {name}",
  'ccm.cis.next': "{n} attempts · next {at}",
  'ccm.cis.goneNote': "Retired or merged in Hive and still active in CITSmart: they stop being updated; inactivating them depends on a route the contract does not have yet.",
  'ccm.cis.f.all': "All",
  'ccm.cis.f.error': "With error",
  'ccm.cis.f.awaiting': "Awaiting return",
  'ccm.cis.f.created': "Created",
  'ccm.cis.f.updated': "Updated",
  'ccm.cis.f.gone': "Retired in Hive, active in CITSmart",
  'ccm.state.new': "Not sent yet",
  'ccm.state.awaiting': "Awaiting return",
  'ccm.state.created': "Created",
  'ccm.state.updated': "Updated",
  'ccm.state.error': "Error",
  'ccm.state.merged': "Merged into another",
  'ccm.state.retired': "Retired",
  'ccm.asset.title': "CITSmart CMDB",
  'ccm.asset.connection': "Connection",
  'ccm.asset.error': "Last error",
  'ccm.access.noTicket': "There is no CITSmart ticket connection yet: connect CITSmart in the catalog first, or use own access.",
  'ccm.attrs.title': "Attributes per type",
  'ccm.attrs.kind': "Type",
  'ccm.attrs.count': "{n} attributes",
  'ccm.attrs.send': "Send",
  'ccm.attrs.target': "Goes to (CITSmart)",
  'ccm.attrs.key': "Key and title in properties",
  'ccm.attrs.locked': "always",
  'ccm.attrs.properties': "properties (key, title, value)",
  'ccm.attrs.targetOf': "Where {attr} goes",
  'ccm.attrs.keyOf': "Key of {attr}",
  'ccm.attrs.titleOf': "Title of {attr}",
  'ccm.attrs.titlePh': "Title",
  'ccm.group.identification': "Identification",
  'ccm.group.system': "System",
  'ccm.group.hardware': "Hardware",
  'ccm.group.network': "Network",
  'ccm.group.software': "Software (normalized)",
  'ccm.group.services': "Services",
  'ccm.group.management': "Management",
  'ccm.group.dates': "Dates",
  'ccm.group.custom': "Custom attributes",
  'ccm.attr.ci_id': "ci_id (HIVE-…)",
  'ccm.attr.name': "Name",
  'ccm.attr.ci_type': "CI type",
  'ccm.attr.hive_asset_id': "Hive asset id",
  'ccm.attr.hostname': "Hostname",
  'ccm.attr.fqdn': "FQDN",
  'ccm.attr.serial': "Serial number",
  'ccm.attr.hw_uuid': "Hardware UUID",
  'ccm.attr.macs': "MAC addresses",
  'ccm.attr.ip': "Main IP",
  'ccm.attr.ips': "All IPs",
  'ccm.attr.os': "Operating system",
  'ccm.attr.os_type': "OS type",
  'ccm.attr.os_version': "OS version",
  'ccm.attr.os_family': "OS family",
  'ccm.attr.memory': "Memory",
  'ccm.attr.cpu': "CPU",
  'ccm.attr.vendor': "Manufacturer",
  'ccm.attr.model': "Model",
  'ccm.attr.memories': "Memory list",
  'ccm.attr.drives': "Disks",
  'ccm.attr.bios': "BIOS",
  'ccm.attr.networks': "Interfaces",
  'ccm.attr.vlan': "VLAN",
  'ccm.attr.subnet': "Subnet",
  'ccm.attr.switch_port': "Switch port",
  'ccm.attr.topology': "Topology (physical links)",
  'ccm.attr.softwares': "Software",
  'ccm.attr.services': "Services",
  'ccm.attr.primary_user': "Owner",
  'ccm.attr.criticality': "Criticality",
  'ccm.attr.lifecycle_stage': "Lifecycle stage",
  'ccm.attr.location': "Location",
  'ccm.attr.site': "Site / branch",
  'ccm.attr.department': "Department",
  'ccm.attr.warranty_end': "Warranty end",
  'ccm.attr.purchase_date': "Purchase date",
  'ccm.attr.created_at': "First seen (created_at)",
  'ccm.attr.updated_at': "Last seen (updated_at)",
  'ccm.class.workstation': "Computers (workstation)",
  'ccm.class.server': "Servers",
  'ccm.class.network': "Network",
  'ccm.class.printer': "Printers",
  'ccm.class.ip_phone': "IP phones",
  'ccm.class.container': "Containers",
  'ccm.class.kubernetes': "Kubernetes nodes",
  'ccm.class.iot': "IoT, cameras and PLCs",
  'ccm.class.host': "Other hosts",
  'ccm.rel.conectado_a': "connected to",
  'ccm.rel.atras_de': "behind",
  'ccm.rel.vizinho_de': "neighbor of",
  'ccm.rel.hospedado_em': "hosted on",
  'ccm.rel.comunica_com': "talks to",
  'ccm.rel.depende_de': "depends on",
  'ccm.wz.autonomous': "The integration with Autonomous is on in this installation: only one platform may feed the CITSmart CMDB of a client. Turning on the sending will ask you to confirm that the CITSmart CMDB of Autonomous is off.",
  'ccm.wz.attributes': "Without changes, Hive sends exactly the object agreed with CITSmart. Changing the selection of a type resends every CI of that type once.",
  'ccm.wz.relations': "Relationships go only in the CI of origin and only between CIs that are sent. Without agreement with CITSmart, only the contract topology goes (physical links with IP and ci_id of both ends). Turning on a type resends once every CI that has it.",
  'ccm.wz.returnOn': "While a CI awaits the return it is not resent. After saving, generate the webhook token on the connection screen and give the address to CITSmart.",
  'ccm.wz.returnOff': "Transition mode: a 2xx answer counts as accepted. Turn the return on only when CITSmart already calls the webhook.",
  'ccm.wz.test': "After connecting, Hive tests the Keycloak token and calls the queue route with an empty list (nothing is recorded). A failure says what failed: token, route, network or certificate.",
  'ccm.wz.done': "The sending stays off: open the connection, check the CI preview and use Turn on sending.",
};

type Keys = keyof typeof en;

const ptBR: Record<Keys, string> = {
  'ccm.impact': "{n} CIs serão reenviados uma vez na próxima volta ({attrs} por atributos, {rels} só por relações). Faça fora do horário de pico.",
  'perm.action.citsmartCmdb.enable': "Ligar o envio para o CMDB do CITSmart",
  'ccm.title': "CMDB do CITSmart",
  'ccm.lead': "O Hive alimenta o CMDB do CITSmart com o contrato combinado com o Autonomous: fila createOrUpdateList, ci_id HIVE-…, só o que mudou, retorno por webhook. A cada 10 minutos enquanto o envio está ligado.",
  'ccm.off.untested': "O envio está desligado. Teste o conector (token do Keycloak e rota da fila), confira a prévia e depois ligue o envio.",
  'ccm.off.tested': "O envio está desligado. O último teste passou: confira a prévia e ligue o envio.",
  'ccm.autonomous.confirmed': "{who} confirmou em {at} que o CMDB do CITSmart do Autonomous está desligado.",
  'ccm.enable.switch': "Envio ligado",
  'ccm.enable.title': "Ligar o envio para o CMDB do CITSmart?",
  'ccm.enable.text': "A próxima volta envia todo ativo elegível que mudou. Na primeira vez, faça fora do horário de pico.",
  'ccm.enable.autonomous': "A integração com o Autonomous está ligada nesta instalação. Só uma plataforma pode alimentar o CMDB do CITSmart de um cliente, senão a mesma máquina vira dois CIs (AUT-… e HIVE-…). Confirme que o CMDB do CITSmart do Autonomous está desligado.",
  'ccm.enable.confirmAutonomous': "O CMDB do Autonomous está desligado: ligar",
  'ccm.enable.ok': "Ligar",
  'ccm.enable.on': "Envio para o CMDB do CITSmart ligado.",
  'ccm.enable.off': "Envio para o CMDB do CITSmart desligado.",
  'ccm.send.now': "Enviar agora",
  'ccm.send.kind': "Enviar por tipo…",
  'ccm.send.byKind': "Enviar este tipo",
  'ccm.send.title': "Enviar agora?",
  'ccm.send.kindTitle': "Enviar só {kind}?",
  'ccm.send.text': "{n} ativos elegíveis são conferidos; só o que mudou é enviado. Com outra volta rodando, esta fica como pulada (registrado na auditoria).",
  'ccm.send.ok': "Enviar",
  'ccm.send.running': "Enviando…",
  'ccm.send.done': "{sent} enviados, {unchanged} sem mudança, {failed} com erro, {waiting} aguardando retorno.",
  'ccm.send.stopped': "A volta parou: {why}.",
  'ccm.queueLink': "Abrir a fila no CITSmart",
  'ccm.kpis': "Indicadores do CMDB do CITSmart",
  'ccm.k.eligible': "Elegíveis",
  'ccm.k.created': "Criados",
  'ccm.k.updated': "Atualizados",
  'ccm.k.awaiting': "Aguardando retorno",
  'ccm.k.oldest': "mais antigo {at}",
  'ccm.k.errors': "Com erro",
  'ccm.k.backoff': "{n} em espera",
  'ccm.k.excluded': "De fora",
  'ccm.excluded': "De fora:",
  'ccm.why.kind': "tipo não escolhido",
  'ccm.why.duplicate': "possível duplicado em revisão",
  'ccm.why.merged': "unido a outro ativo",
  'ccm.why.retired': "retirado",
  'ccm.last.origin': "Última volta",
  'ccm.last.when': "Começou",
  'ccm.last.duration': "Duração",
  'ccm.last.sent': "Resultado",
  'ccm.last.counts': "{sent} enviados · {unchanged} sem mudança · {failed} erros",
  'ccm.last.stopped': "Interrompida",
  'ccm.last.notStopped': "Não",
  'ccm.origin.loop': "Automática (a cada 10 min)",
  'ccm.origin.now': "Enviar agora",
  'ccm.origin.kind': "Enviar por tipo",
  'ccm.gone': "{n} CIs foram retirados ou unidos no Hive mas continuam ativos no CITSmart: o contrato ainda não tem rota para inativar (veja a aba CIs).",
  'ccm.tabs': "Seções do CMDB do CITSmart",
  'ccm.tab.webhook': "Retorno (webhook)",
  'ccm.tab.preview': "Prévia do CI",
  'ccm.tab.attempts': "Auditoria",
  'ccm.tab.runs': "Voltas",
  'ccm.tab.cis': "CIs",
  'ccm.wh.mode': "Retorno",
  'ccm.wh.async': "Assíncrono pelo webhook (erro depois de {h} h sem retorno)",
  'ccm.wh.sync': "Transição: resposta 2xx vale como aceito",
  'ccm.wh.url': "Endereço do webhook (passe ao CITSmart)",
  'ccm.wh.header': "Cabeçalho do token",
  'ccm.wh.token': "Token",
  'ccm.wh.tokenSet': "Configurado (só o SHA-256 fica guardado)",
  'ccm.wh.tokenMissing': "Não gerado: o webhook responde 503",
  'ccm.wh.version': "Versão da seleção de atributos",
  'ccm.wh.route': "Rota da fila",
  'ccm.wh.tested': "Último teste aprovado",
  'ccm.wh.generate': "Gerar token",
  'ccm.wh.new': "Gerar novo token",
  'ccm.wh.newTitle': "Trocar o token do webhook?",
  'ccm.wh.newText': "O token atual para de valer na hora: o CITSmart precisa receber o novo.",
  'ccm.wh.once': "Copie agora: ele aparece só uma vez.",
  'ccm.wh.network': "Ligue o retorno assíncrono só depois de o CITSmart estar chamando o webhook. O CITSmart precisa alcançar este endereço; o teste só prova que o Hive alcança o CITSmart, não o contrário.",
  'ccm.pv.search': "Ativo (nome, IP ou serial)",
  'ccm.pv.find': "Procurar",
  'ccm.pv.excluded': "Este ativo não vai para o CMDB: {why}.",
  'ccm.pv.nulls': "Sem fonte no Hive (vão nulos ou vazios): {list}",
  'ccm.pv.held': "Relação {type} ainda não vai: {why}.",
  'ccm.pv.payload': "Envelope e jsondata exatos",
  'ccm.held.target-not-accepted': "a outra ponta ainda não foi aceita pelo CITSmart (entra no envio seguinte à confirmação)",
  'ccm.held.target-not-sent': "a outra ponta não vai para o CMDB (tipo não escolhido, duplicado ou retirado)",
  'ccm.at.ciId': "ci_id",
  'ccm.at.outcome': "Situação",
  'ccm.at.from': "Desde",
  'ccm.at.when': "Quando",
  'ccm.at.asset': "Ativo",
  'ccm.at.result': "Retorno",
  'ccm.at.empty': "Nenhuma tentativa com estes filtros.",
  'ccm.at.detail': "Tentativa {id}",
  'ccm.at.payload': "Payload enviado",
  'ccm.at.response': "Resposta HTTP",
  'ccm.at.results': "Retornos recebidos do CITSmart",
  'ccm.out.accepted': "Aceito",
  'ccm.out.sent': "Enviado, aguardando retorno",
  'ccm.out.failed': "Falhou",
  'ccm.out.reserved': "Reservado",
  'ccm.out.awaiting-not-resent': "Aguardando retorno, não reenviado",
  'ccm.out.no-return': "Sem retorno no prazo",
  'ccm.out.not-configured': "Sem configuração",
  'ccm.out.skipped-run': "Volta pulada",
  'ccm.out.breaker-open': "Volta interrompida (disjuntor)",
  'ccm.runs.empty': "Nenhuma volta ainda.",
  'ccm.cis.state': "Situação",
  'ccm.cis.last': "Último retorno",
  'ccm.cis.empty': "Nenhum CI nesta situação.",
  'ccm.cis.merged': "unido a {name}",
  'ccm.cis.next': "{n} tentativas · próxima {at}",
  'ccm.cis.goneNote': "Retirados ou unidos no Hive e ainda ativos no CITSmart: param de ser atualizados; inativar lá depende de uma rota que o contrato ainda não tem.",
  'ccm.cis.f.all': "Todos",
  'ccm.cis.f.error': "Com erro",
  'ccm.cis.f.awaiting': "Aguardando retorno",
  'ccm.cis.f.created': "Criados",
  'ccm.cis.f.updated': "Atualizados",
  'ccm.cis.f.gone': "Retirado no Hive, ativo no CITSmart",
  'ccm.state.new': "Ainda não enviado",
  'ccm.state.awaiting': "Aguardando retorno",
  'ccm.state.created': "Criado",
  'ccm.state.updated': "Atualizado",
  'ccm.state.error': "Erro",
  'ccm.state.merged': "Unido a outro",
  'ccm.state.retired': "Retirado",
  'ccm.asset.title': "CMDB do CITSmart",
  'ccm.asset.connection': "Conexão",
  'ccm.asset.error': "Último erro",
  'ccm.access.noTicket': "Ainda não há conexão de chamados do CITSmart: conecte o CITSmart no catálogo antes, ou use dados próprios.",
  'ccm.attrs.title': "Atributos por tipo",
  'ccm.attrs.kind': "Tipo",
  'ccm.attrs.count': "{n} atributos",
  'ccm.attrs.send': "Enviar",
  'ccm.attrs.target': "Vai para (CITSmart)",
  'ccm.attrs.key': "Chave e título no properties",
  'ccm.attrs.locked': "sempre",
  'ccm.attrs.properties': "properties (chave, título, valor)",
  'ccm.attrs.targetOf': "Para onde vai {attr}",
  'ccm.attrs.keyOf': "Chave de {attr}",
  'ccm.attrs.titleOf': "Título de {attr}",
  'ccm.attrs.titlePh': "Título",
  'ccm.group.identification': "Identificação",
  'ccm.group.system': "Sistema",
  'ccm.group.hardware': "Hardware",
  'ccm.group.network': "Rede",
  'ccm.group.software': "Software (normalizado)",
  'ccm.group.services': "Serviços",
  'ccm.group.management': "Gestão",
  'ccm.group.dates': "Datas",
  'ccm.group.custom': "Atributos personalizados",
  'ccm.attr.ci_id': "ci_id (HIVE-…)",
  'ccm.attr.name': "Nome",
  'ccm.attr.ci_type': "Tipo do CI",
  'ccm.attr.hive_asset_id': "Id do ativo no Hive",
  'ccm.attr.hostname': "Hostname",
  'ccm.attr.fqdn': "FQDN",
  'ccm.attr.serial': "Número de série",
  'ccm.attr.hw_uuid': "UUID de hardware",
  'ccm.attr.macs': "Endereços MAC",
  'ccm.attr.ip': "IP principal",
  'ccm.attr.ips': "Todos os IPs",
  'ccm.attr.os': "Sistema operacional",
  'ccm.attr.os_type': "Tipo do sistema",
  'ccm.attr.os_version': "Versão do sistema",
  'ccm.attr.os_family': "Família do sistema",
  'ccm.attr.memory': "Memória",
  'ccm.attr.cpu': "CPU",
  'ccm.attr.vendor': "Fabricante",
  'ccm.attr.model': "Modelo",
  'ccm.attr.memories': "Lista de memórias",
  'ccm.attr.drives': "Discos",
  'ccm.attr.bios': "BIOS",
  'ccm.attr.networks': "Interfaces",
  'ccm.attr.vlan': "VLAN",
  'ccm.attr.subnet': "Sub-rede",
  'ccm.attr.switch_port': "Porta do switch",
  'ccm.attr.topology': "Topologia (enlaces físicos)",
  'ccm.attr.softwares': "Software",
  'ccm.attr.services': "Serviços",
  'ccm.attr.primary_user': "Responsável",
  'ccm.attr.criticality': "Criticidade",
  'ccm.attr.lifecycle_stage': "Etapa do ciclo de vida",
  'ccm.attr.location': "Local",
  'ccm.attr.site': "Site / filial",
  'ccm.attr.department': "Departamento",
  'ccm.attr.warranty_end': "Fim da garantia",
  'ccm.attr.purchase_date': "Data da compra",
  'ccm.attr.created_at': "Primeira vez visto (created_at)",
  'ccm.attr.updated_at': "Última vez visto (updated_at)",
  'ccm.class.workstation': "Computadores (workstation)",
  'ccm.class.server': "Servidores",
  'ccm.class.network': "Rede",
  'ccm.class.printer': "Impressoras",
  'ccm.class.ip_phone': "Telefones IP",
  'ccm.class.container': "Contêineres",
  'ccm.class.kubernetes': "Nós do Kubernetes",
  'ccm.class.iot': "IoT, câmeras e CLPs",
  'ccm.class.host': "Outros hosts",
  'ccm.rel.conectado_a': "conectado a",
  'ccm.rel.atras_de': "atrás de",
  'ccm.rel.vizinho_de': "vizinho de",
  'ccm.rel.hospedado_em': "hospedado em",
  'ccm.rel.comunica_com': "comunica com",
  'ccm.rel.depende_de': "depende de",
  'ccm.wz.autonomous': "A integração com o Autonomous está ligada nesta instalação: só uma plataforma pode alimentar o CMDB do CITSmart de um cliente. Ao ligar o envio, você confirma que o CMDB do CITSmart do Autonomous está desligado.",
  'ccm.wz.attributes': "Sem mexer, o Hive envia exatamente o objeto combinado com o CITSmart. Mudar a seleção de um tipo reenvia uma vez todos os CIs daquele tipo.",
  'ccm.wz.relations': "As relações vão só no CI de origem e só entre CIs enviados. Sem acordo com o CITSmart, só a topologia do contrato vai (enlaces físicos com IP e ci_id das duas pontas). Ligar um tipo reenvia uma vez todo CI que o tem.",
  'ccm.wz.returnOn': "Enquanto um CI aguarda o retorno, ele não é reenviado. Depois de salvar, gere o token do webhook na tela da conexão e passe o endereço ao CITSmart.",
  'ccm.wz.returnOff': "Modo de transição: resposta 2xx vale como aceito. Ligue o retorno só quando o CITSmart já chamar o webhook.",
  'ccm.wz.test': "Depois de conectar, o Hive testa o token do Keycloak e chama a rota da fila com uma lista vazia (nada é gravado). A falha diz o que falhou: token, rota, rede ou certificado.",
  'ccm.wz.done': "O envio fica desligado: abra a conexão, confira a prévia do CI e use Ligar envio.",
};

const es: Record<Keys, string> = {
  'ccm.impact': "{n} CI se reenviarán una vez en la próxima ronda ({attrs} por atributos, {rels} solo por relaciones). Hágalo fuera del horario pico.",
  'perm.action.citsmartCmdb.enable': "Activar el envío al CMDB de CITSmart",
  'ccm.title': "CMDB de CITSmart",
  'ccm.lead': "Hive alimenta el CMDB de CITSmart con el contrato acordado con Autonomous: cola createOrUpdateList, ci_id HIVE-…, solo lo que cambió, retorno por webhook. Cada 10 minutos mientras el envío está activo.",
  'ccm.off.untested': "El envío está apagado. Pruebe el conector (token de Keycloak y ruta de la cola), revise la vista previa y luego active el envío.",
  'ccm.off.tested': "El envío está apagado. La última prueba pasó: revise la vista previa y active el envío.",
  'ccm.autonomous.confirmed': "{who} confirmó el {at} que el CMDB de CITSmart de Autonomous está apagado.",
  'ccm.enable.switch': "Envío activo",
  'ccm.enable.title': "¿Activar el envío al CMDB de CITSmart?",
  'ccm.enable.text': "La próxima ronda envía todo activo elegible que cambió. La primera vez, hágalo fuera del horario pico.",
  'ccm.enable.autonomous': "La integración con Autonomous está activa en esta instalación. Solo una plataforma puede alimentar el CMDB de CITSmart de un cliente; si no, la misma máquina se vuelve dos CI (AUT-… y HIVE-…). Confirme que el CMDB de CITSmart de Autonomous está apagado.",
  'ccm.enable.confirmAutonomous': "El CMDB de Autonomous está apagado: activar",
  'ccm.enable.ok': "Activar",
  'ccm.enable.on': "Envío al CMDB de CITSmart activado.",
  'ccm.enable.off': "Envío al CMDB de CITSmart apagado.",
  'ccm.send.now': "Enviar ahora",
  'ccm.send.kind': "Enviar por tipo…",
  'ccm.send.byKind': "Enviar este tipo",
  'ccm.send.title': "¿Enviar ahora?",
  'ccm.send.kindTitle': "¿Enviar solo {kind}?",
  'ccm.send.text': "Se revisan {n} activos elegibles; solo se envía lo que cambió. Con otra ronda en curso, esta queda como omitida (registrado en la auditoría).",
  'ccm.send.ok': "Enviar",
  'ccm.send.running': "Enviando…",
  'ccm.send.done': "{sent} enviados, {unchanged} sin cambios, {failed} con error, {waiting} esperando retorno.",
  'ccm.send.stopped': "La ronda se detuvo: {why}.",
  'ccm.queueLink': "Abrir la cola en CITSmart",
  'ccm.kpis': "Indicadores del CMDB de CITSmart",
  'ccm.k.eligible': "Elegibles",
  'ccm.k.created': "Creados",
  'ccm.k.updated': "Actualizados",
  'ccm.k.awaiting': "Esperando retorno",
  'ccm.k.oldest': "más antiguo {at}",
  'ccm.k.errors': "Con error",
  'ccm.k.backoff': "{n} en espera",
  'ccm.k.excluded': "Fuera",
  'ccm.excluded': "Fuera:",
  'ccm.why.kind': "tipo no elegido",
  'ccm.why.duplicate': "posible duplicado en revisión",
  'ccm.why.merged': "unido a otro activo",
  'ccm.why.retired': "retirado",
  'ccm.last.origin': "Última ronda",
  'ccm.last.when': "Comenzó",
  'ccm.last.duration': "Duración",
  'ccm.last.sent': "Resultado",
  'ccm.last.counts': "{sent} enviados · {unchanged} sin cambios · {failed} errores",
  'ccm.last.stopped': "Interrumpida",
  'ccm.last.notStopped': "No",
  'ccm.origin.loop': "Automática (cada 10 min)",
  'ccm.origin.now': "Enviar ahora",
  'ccm.origin.kind': "Enviar por tipo",
  'ccm.gone': "{n} CI se retiraron o unieron en Hive pero siguen activos en CITSmart: el contrato aún no tiene ruta para inactivarlos (vea la pestaña CI).",
  'ccm.tabs': "Secciones del CMDB de CITSmart",
  'ccm.tab.webhook': "Retorno (webhook)",
  'ccm.tab.preview': "Vista previa del CI",
  'ccm.tab.attempts': "Auditoría",
  'ccm.tab.runs': "Rondas",
  'ccm.tab.cis': "CI",
  'ccm.wh.mode': "Retorno",
  'ccm.wh.async': "Asíncrono por webhook (error después de {h} h sin retorno)",
  'ccm.wh.sync': "Transición: una respuesta 2xx vale como aceptada",
  'ccm.wh.url': "Dirección del webhook (entréguela a CITSmart)",
  'ccm.wh.header': "Encabezado del token",
  'ccm.wh.token': "Token",
  'ccm.wh.tokenSet': "Configurado (solo se guarda su SHA-256)",
  'ccm.wh.tokenMissing': "No generado: el webhook responde 503",
  'ccm.wh.version': "Versión de la selección de atributos",
  'ccm.wh.route': "Ruta de la cola",
  'ccm.wh.tested': "Última prueba aprobada",
  'ccm.wh.generate': "Generar token",
  'ccm.wh.new': "Generar nuevo token",
  'ccm.wh.newTitle': "¿Reemplazar el token del webhook?",
  'ccm.wh.newText': "El token actual deja de valer de inmediato: CITSmart debe recibir el nuevo.",
  'ccm.wh.once': "Cópielo ahora: se muestra solo una vez.",
  'ccm.wh.network': "Active el retorno asíncrono solo después de que CITSmart esté llamando al webhook. CITSmart debe alcanzar esta dirección; la prueba solo demuestra que Hive alcanza a CITSmart, no al revés.",
  'ccm.pv.search': "Activo (nombre, IP o serie)",
  'ccm.pv.find': "Buscar",
  'ccm.pv.excluded': "Este activo no va al CMDB: {why}.",
  'ccm.pv.nulls': "Sin fuente en Hive (van nulos o vacíos): {list}",
  'ccm.pv.held': "Relación {type} aún no se envía: {why}.",
  'ccm.pv.payload': "Sobre y jsondata exactos",
  'ccm.held.target-not-accepted': "el otro extremo aún no fue aceptado por CITSmart (entra en el envío siguiente a la confirmación)",
  'ccm.held.target-not-sent': "el otro extremo no va al CMDB (tipo no elegido, duplicado o retirado)",
  'ccm.at.ciId': "ci_id",
  'ccm.at.outcome': "Situación",
  'ccm.at.from': "Desde",
  'ccm.at.when': "Cuándo",
  'ccm.at.asset': "Activo",
  'ccm.at.result': "Retorno",
  'ccm.at.empty': "Ningún intento con estos filtros.",
  'ccm.at.detail': "Intento {id}",
  'ccm.at.payload': "Payload enviado",
  'ccm.at.response': "Respuesta HTTP",
  'ccm.at.results': "Retornos recibidos de CITSmart",
  'ccm.out.accepted': "Aceptado",
  'ccm.out.sent': "Enviado, esperando retorno",
  'ccm.out.failed': "Falló",
  'ccm.out.reserved': "Reservado",
  'ccm.out.awaiting-not-resent': "Esperando retorno, no reenviado",
  'ccm.out.no-return': "Sin retorno a tiempo",
  'ccm.out.not-configured': "Sin configuración",
  'ccm.out.skipped-run': "Ronda omitida",
  'ccm.out.breaker-open': "Ronda interrumpida (disyuntor)",
  'ccm.runs.empty': "Ninguna ronda aún.",
  'ccm.cis.state': "Situación",
  'ccm.cis.last': "Último retorno",
  'ccm.cis.empty': "Ningún CI en esta situación.",
  'ccm.cis.merged': "unido a {name}",
  'ccm.cis.next': "{n} intentos · siguiente {at}",
  'ccm.cis.goneNote': "Retirados o unidos en Hive y aún activos en CITSmart: dejan de actualizarse; inactivarlos depende de una ruta que el contrato aún no tiene.",
  'ccm.cis.f.all': "Todos",
  'ccm.cis.f.error': "Con error",
  'ccm.cis.f.awaiting': "Esperando retorno",
  'ccm.cis.f.created': "Creados",
  'ccm.cis.f.updated': "Actualizados",
  'ccm.cis.f.gone': "Retirado en Hive, activo en CITSmart",
  'ccm.state.new': "Aún no enviado",
  'ccm.state.awaiting': "Esperando retorno",
  'ccm.state.created': "Creado",
  'ccm.state.updated': "Actualizado",
  'ccm.state.error': "Error",
  'ccm.state.merged': "Unido a otro",
  'ccm.state.retired': "Retirado",
  'ccm.asset.title': "CMDB de CITSmart",
  'ccm.asset.connection': "Conexión",
  'ccm.asset.error': "Último error",
  'ccm.access.noTicket': "Aún no hay conexión de tickets de CITSmart: conecte CITSmart en el catálogo antes, o use datos propios.",
  'ccm.attrs.title': "Atributos por tipo",
  'ccm.attrs.kind': "Tipo",
  'ccm.attrs.count': "{n} atributos",
  'ccm.attrs.send': "Enviar",
  'ccm.attrs.target': "Va a (CITSmart)",
  'ccm.attrs.key': "Clave y título en properties",
  'ccm.attrs.locked': "siempre",
  'ccm.attrs.properties': "properties (clave, título, valor)",
  'ccm.attrs.targetOf': "A dónde va {attr}",
  'ccm.attrs.keyOf': "Clave de {attr}",
  'ccm.attrs.titleOf': "Título de {attr}",
  'ccm.attrs.titlePh': "Título",
  'ccm.group.identification': "Identificación",
  'ccm.group.system': "Sistema",
  'ccm.group.hardware': "Hardware",
  'ccm.group.network': "Red",
  'ccm.group.software': "Software (normalizado)",
  'ccm.group.services': "Servicios",
  'ccm.group.management': "Gestión",
  'ccm.group.dates': "Fechas",
  'ccm.group.custom': "Atributos personalizados",
  'ccm.attr.ci_id': "ci_id (HIVE-…)",
  'ccm.attr.name': "Nombre",
  'ccm.attr.ci_type': "Tipo de CI",
  'ccm.attr.hive_asset_id': "Id del activo en Hive",
  'ccm.attr.hostname': "Hostname",
  'ccm.attr.fqdn': "FQDN",
  'ccm.attr.serial': "Número de serie",
  'ccm.attr.hw_uuid': "UUID de hardware",
  'ccm.attr.macs': "Direcciones MAC",
  'ccm.attr.ip': "IP principal",
  'ccm.attr.ips': "Todas las IP",
  'ccm.attr.os': "Sistema operativo",
  'ccm.attr.os_type': "Tipo de sistema",
  'ccm.attr.os_version': "Versión del sistema",
  'ccm.attr.os_family': "Familia del sistema",
  'ccm.attr.memory': "Memoria",
  'ccm.attr.cpu': "CPU",
  'ccm.attr.vendor': "Fabricante",
  'ccm.attr.model': "Modelo",
  'ccm.attr.memories': "Lista de memorias",
  'ccm.attr.drives': "Discos",
  'ccm.attr.bios': "BIOS",
  'ccm.attr.networks': "Interfaces",
  'ccm.attr.vlan': "VLAN",
  'ccm.attr.subnet': "Subred",
  'ccm.attr.switch_port': "Puerto del switch",
  'ccm.attr.topology': "Topología (enlaces físicos)",
  'ccm.attr.softwares': "Software",
  'ccm.attr.services': "Servicios",
  'ccm.attr.primary_user': "Responsable",
  'ccm.attr.criticality': "Criticidad",
  'ccm.attr.lifecycle_stage': "Etapa del ciclo de vida",
  'ccm.attr.location': "Ubicación",
  'ccm.attr.site': "Sitio / sucursal",
  'ccm.attr.department': "Departamento",
  'ccm.attr.warranty_end': "Fin de la garantía",
  'ccm.attr.purchase_date': "Fecha de compra",
  'ccm.attr.created_at': "Primera vez visto (created_at)",
  'ccm.attr.updated_at': "Última vez visto (updated_at)",
  'ccm.class.workstation': "Computadoras (workstation)",
  'ccm.class.server': "Servidores",
  'ccm.class.network': "Red",
  'ccm.class.printer': "Impresoras",
  'ccm.class.ip_phone': "Teléfonos IP",
  'ccm.class.container': "Contenedores",
  'ccm.class.kubernetes': "Nodos de Kubernetes",
  'ccm.class.iot': "IoT, cámaras y PLC",
  'ccm.class.host': "Otros hosts",
  'ccm.rel.conectado_a': "conectado a",
  'ccm.rel.atras_de': "detrás de",
  'ccm.rel.vizinho_de': "vecino de",
  'ccm.rel.hospedado_em': "alojado en",
  'ccm.rel.comunica_com': "se comunica con",
  'ccm.rel.depende_de': "depende de",
  'ccm.wz.autonomous': "La integración con Autonomous está activa en esta instalación: solo una plataforma puede alimentar el CMDB de CITSmart de un cliente. Al activar el envío, confirmará que el CMDB de CITSmart de Autonomous está apagado.",
  'ccm.wz.attributes': "Sin cambios, Hive envía exactamente el objeto acordado con CITSmart. Cambiar la selección de un tipo reenvía una vez todos los CI de ese tipo.",
  'ccm.wz.relations': "Las relaciones van solo en el CI de origen y solo entre CI enviados. Sin acuerdo con CITSmart, solo va la topología del contrato (enlaces físicos con IP y ci_id de ambos extremos). Activar un tipo reenvía una vez todo CI que lo tiene.",
  'ccm.wz.returnOn': "Mientras un CI espera el retorno, no se reenvía. Después de guardar, genere el token del webhook en la pantalla de la conexión y entregue la dirección a CITSmart.",
  'ccm.wz.returnOff': "Modo de transición: una respuesta 2xx vale como aceptada. Active el retorno solo cuando CITSmart ya llame al webhook.",
  'ccm.wz.test': "Después de conectar, Hive prueba el token de Keycloak y llama a la ruta de la cola con una lista vacía (no se graba nada). La falla dice qué falló: token, ruta, red o certificado.",
  'ccm.wz.done': "El envío queda apagado: abra la conexión, revise la vista previa del CI y use Activar envío.",
};

export const citsmartCmdbMessages = { en, 'pt-BR': ptBR, es } as const;
